import {
    CREATE_CUTTING_DC_FAILURE_DK,
    CREATE_CUTTING_DC_REQUEST_DK,
    CREATE_CUTTING_DC_SUCCESS_DK,
    CREATE_USER_FORM_CUTTING_DC_DK,
    FETCH_SINGLE_CUTTING_DC_FAILURE_DK,
    FETCH_SINGLE_CUTTING_DC_REQUEST_DK,
    FETCH_SINGLE_CUTTING_DC_SUCCESS_DK,
    FETCH_CUTTING_DC_FAILURE_DK,
    FETCH_CUTTING_DC_REQUEST_DK,
    FETCH_CUTTING_DC_SUCCESS_DK,
    NAVIGATE_CUTTING_DC_DETAILS_DK,
    NAVIGATE_CUTTING_DC_DK,
    CUTTING_DC_USERFORM_RESET_DK,
    UPDATE_CUTTING_DC_FAILURE_DK,
    UPDATE_CUTTING_DC_REQUEST_DK,
    UPDATE_CUTTING_DC_SUCCESS_DK,
    DELETE_CUTTING_DC_REQUEST_DK,
    DELETE_CUTTING_DC_SUCCESS_DK,
    DELETE_CUTTING_DC_FAILURE_DK,
    CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_CUTTING_DC_INVOICE_REQUEST,
    FETCH_CUTTING_DC_INVOICE_SUCCESS,
    FETCH_CUTTING_DC_INVOICE_FAILURE,
    RESET_CUTTING_DC_INVOICE,
    FETCH_CUTTING_DC_STYLE_REQUEST_DK,
    FETCH_CUTTING_DC_STYLE_SUCCESS_DK,
    FETCH_CUTTING_DC_STYLE_FAILURE_DK,
    FETCH_CUTTING_DC_FORMAT_REQUEST_DK,
    FETCH_CUTTING_DC_FORMAT_SUCCESS_DK,
    FETCH_CUTTING_DC_FORMAT_FAILURE_DK,
    FETCH_CUTTING_DC_PRINTING_LIST_REQUEST_DK,
    FETCH_CUTTING_DC_PRINTING_LIST_SUCCESS_DK,
    FETCH_CUTTING_DC_PRINTING_LIST_FAILURE_DK,
    RESET_PRINT_DATA_FOR_EDIT_CUTTING
} from './cuttingDC.actionsType';

export const CUTTING_DC_DK = 'cuttingDcDK';

let initialState = {
    loading: false,
    cuttingDC: [],
    cuttingDCInvoice: [],
    cuttingDCStyle: [],
    cuttingDCFormat: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedCuttingDC: {},
    detailsId: '',
    activeKey: 1,
    isCuttingDC: false,
    cuttingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    cuttingPrintingGridData: []
};

export let cuttingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_DC_REQUEST_DK:
        case FETCH_CUTTING_DC_STYLE_REQUEST_DK:
        case FETCH_CUTTING_DC_FORMAT_REQUEST_DK:
        case FETCH_CUTTING_DC_INVOICE_REQUEST:
        case CREATE_CUTTING_DC_REQUEST_DK:
        case FETCH_SINGLE_CUTTING_DC_REQUEST_DK:
        case UPDATE_CUTTING_DC_REQUEST_DK:
        case DELETE_CUTTING_DC_REQUEST_DK:
        case FETCH_CUTTING_DC_PRINTING_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDC: updatePayload
            };
        case FETCH_CUTTING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCStyle: updatePayload?.PONO
            };
        case FETCH_CUTTING_DC_FORMAT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingDCFormat: updatePayload
            };
        case FETCH_CUTTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCInvoice: updatePayload
            };

        case FETCH_CUTTING_DC_PRINTING_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingPrintingGridData: updatePayload
            };

        case RESET_PRINT_DATA_FOR_EDIT_CUTTING:
            return {
                ...state,
                loading: false,
                cuttingPrintingGridData: []
            };

        case CREATE_CUTTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_CUTTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCuttingDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_CUTTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCuttingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_CUTTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedCuttingDC: {}
            };
        case FETCH_CUTTING_DC_FAILURE_DK:
        case FETCH_CUTTING_DC_STYLE_FAILURE_DK:
        case FETCH_CUTTING_DC_FORMAT_FAILURE_DK:
        case FETCH_CUTTING_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_CUTTING_DC_FAILURE_DK:
        case CREATE_CUTTING_DC_FAILURE_DK:
        case UPDATE_CUTTING_DC_FAILURE_DK:
        case DELETE_CUTTING_DC_FAILURE_DK:
        case FETCH_CUTTING_DC_PRINTING_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_CUTTING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CUTTING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedCuttingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_CUTTING_DC_DETAILS_DK:
            return {
                ...state,
                isCuttingDC: true,
                cuttingDCSelectedValue: updatePayload.cuttingDCSelectedValue
            };
        case NAVIGATE_CUTTING_DC_DK:
            return {
                ...state,
                isCuttingDC: false
            };
        case RESET_CUTTING_DC_INVOICE:
            return {
                ...state,
                cuttingDCInvoice: []
            };
        case CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
